/**
 * Usage:
 * import { createElementFromHtml } from '@local_modules/generic/dom/create-elements-from-html.js'
 *
 * @param {String} elementHtml
 * @param {String} [querySelector] - eg. return the 'select' element
 * @returns {Element}
 */
export function createElementFromHtml (elementHtml, querySelector) {
  const parser = new DOMParser()
  const htmlDoc = parser.parseFromString(elementHtml, 'text/html')
  const createdElement = htmlDoc.body.firstChild

  if (querySelector) {
    return htmlDoc.querySelector(querySelector)
  }

  return createdElement
}
